export default __webpack_public_path__ + "static/media/leadrpro_logo_1.c8fb4a7d.svg";